module.exports = __webpack_public_path__ + "static/media/android-download.66b11e81.png";